import React, { useCallback } from "react"
import Select from "react-select"
import { Props } from "react-select/base"
import { ChannelIcon } from "../../../../components/parts/channel-icon"
import styled from "styled-components"
import { Channel } from "../../../../rpcs/dist/ChannelRPC"
import { User } from "../../../../rpcs/dist/UserRPC"
import Color from "../../../../style/enum/color"
import { UserIcon } from "../../../../components/parts/user-icon"
import { Headline } from "../headline"
import { Container, IContainerProps } from "./container"

const CustomOption = (props: Props) => {
  const { data, innerProps } = props
  const isChannel = data && (data as Channel).isDefault !== undefined

  // ユーザー投稿
  if (!isChannel) {
    return (
      <StyledWrapper {...innerProps}>
        <UserIcon size={35} title={"ユーザー"} url={data.profileImage.square} />
        <Label>{data.screenName}</Label>
      </StyledWrapper>
    )
  }

  // チャンネル投稿
  return (
    <StyledWrapper {...innerProps}>
      <ChannelIcon
        size={35}
        title={"チャンネル"}
        profileImage={data.profileImage}
      />
      <Label>{data.screenName}</Label>
    </StyledWrapper>
  )
}

export const SelectPostAccount = Container((props: IContainerProps) => {
  const onChange = useCallback(
    (selected: Channel | User) => {
      const isChannel = (selected as Channel).isDefault !== undefined
      if (isChannel) {
        props.actions.selectPostAccount((selected as Channel).id)
      } else {
        props.actions.selectPostAccount(null)
      }
    },
    // eslint-disable-next-line
    [],
  )

  const selectedChannel = (props.channels || []).find(
    c => c.id === props.selectedChannelId,
  )

  return (
    <Wrapper>
      <Headline>投稿先を選択</Headline>
      <Select<User | Channel>
        value={selectedChannel || props.currentUser}
        options={[props.currentUser as User, ...(props.channels || [])]}
        isSearchable={false}
        components={{
          Option: CustomOption,
          SingleValue: CustomOption,
        }}
        onChange={onChange}
      />
    </Wrapper>
  )
})

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 5px;
  cursor: pointer;
  width: 99%;
  & + & {
    border-top: 1px solid ${Color.LIGHT_GRAY};
  }
`

const Label = styled.div`
  margin-left: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

const Wrapper = styled.div`
  margin: 20px 0;
`
